import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Calendar, Clock } from "lucide-react";
import { format } from "date-fns";
import { ja } from "date-fns/locale";
import { motion } from "framer-motion";
import { Link } from "wouter";
import type { Blog } from "@shared/types";

interface BlogCardProps {
  blog: Blog;
  index?: number;
}

export function BlogCard({ blog, index = 0 }: BlogCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
    >
      <Link href={`/blog/${blog.id}`}>
        <Card className="h-full hover:shadow-lg transition-shadow duration-300 cursor-pointer group">
          {blog.eyecatch && (
            <div className="relative overflow-hidden rounded-t-lg">
              <img
                src={blog.eyecatch.url}
                alt={blog.title}
                className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </div>
          )}
          <CardHeader className="pb-2">
            <div className="flex items-center gap-2 mb-2">
              <Badge variant="secondary" className="text-xs">
                {blog.category?.name || 'カテゴリなし'}
              </Badge>
            </div>
            <h3 className="text-xl font-semibold line-clamp-2 group-hover:text-foreground/80 dark:group-hover:text-foreground transition-colors">
              {blog.title}
            </h3>
          </CardHeader>
          <CardContent>
            <div className="flex items-center justify-between text-sm text-muted-foreground">
              <div className="flex items-center gap-4">
                {blog.publishedAt && (
                  <div className="flex items-center gap-1">
                    <Calendar className="w-4 h-4" />
                    <time dateTime={blog.publishedAt}>
                      {format(new Date(blog.publishedAt), "yyyy年MM月dd日", { locale: ja })}
                    </time>
                  </div>
                )}
              </div>
            </div>
          </CardContent>
        </Card>
      </Link>
    </motion.div>
  );
}